import React from 'react';
import Footer from '../Footer';
import Header from '../Header';
import CreateToken from './CreateToken';
import Head from './Head';

export default function PolygonIndex(props) {

 

  return (
    <>
      <Header  confirm={props.confirm}
      confirmbutton={props.confirmbutton}
      network={props.network}  changenetwork={props.changenetwork}
       />
      <Head  />
      <CreateToken 
      confirm={props.confirm}
      confirmbutton={props.confirmbutton}
      network={props.network}  changenetwork={props.changenetwork}
       />
      <Footer />

    </>
  )

}
